<template>
<div>
  <div class="table-page-search-wrapper">
    <a-form layout="inline" @keyup.enter.native="searchByquery">
      <a-row :gutter="24" v-if="showSearchFlag">
        <template v-for="(item,index) in queryInfo">
          <template v-if=" item.hidden==='1' ">
            <a-col :md="8" :sm="24" :key=" 'query'+index " v-show="toggleSearchStatus">
              <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
            </a-col>
          </template>
          <template v-else>
            <a-col :md="8" :sm="24" :key=" 'query'+index ">
              <online-query-form-item :queryParam="queryParam" :item="item" :dictOptions="dictOptions" />
            </a-col>
          </template>
        </template>
        <a-col :md="8" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchByquery" icon="search" text="button.search" />
              <mtc-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" text="button.reset" />
              <a @click="handleToggleSearch" style="margin-left: 8px">
                <mtcLangPopover :text="toggleSearchStatus? 'tip.up': 'tip.down'" />
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
        </a-col>
      </a-row>
    </a-form>
  </div>
  <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
    <i class="anticon anticon-info-circle ant-alert-icon"></i>
    {{ $t('tip.selected') }}&nbsp;<a style="font-weight: 600">{{ table.selectedRowKeys.length }}</a>{{ $t('tip.term') }}&nbsp;&nbsp;
    <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
    <a v-if="!showSearchFlag" style="margin-left: 24px" @click="onlyReload">{{ $t('systemBase.shuaxin') }}</a>
  </div>
  <a-table ref="table"
           size="middle"
           bordered
           :rowKey="combineRowKey"
           :columns="table.columns"
           :dataSource="table.dataSource"
           :pagination="table.pagination"
           :loading="table.loading"
           :rowSelection="{fixed:true,selectedRowKeys: table.selectedRowKeys, onChange: handleChangeInTableSelect}"
           @change="handleChangeInTable"
           style="min-height: 300px"
           :scroll="tableScroll"
           :customRow="clickThenCheck">
    <!-- 表头自定义渲染 -->
    <template v-for="(item, index) in table.columns" :slot="item.slotName">
      <mtcHeader :key="index" :text="item.slotName" />
    </template>
  </a-table>
</div>
</template>

<script>
import { getAction } from '@/api/manage'
import { filterObj } from '@/utils/util'
import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
import { httpGroupRequest } from '@/api/GroupRequest.js'
import OnlineQueryFormItem from '@comp/online/autoform/OnlineQueryFormItem'
import PropTypes from 'ant-design-vue/lib/_util/vue-types'

export default {
  name: 'modalPopup',
  components: {
    OnlineQueryFormItem
  },
  props: {
    detailData: PropTypes.object.def(() => ({
      // 是否多选
      multi: true,
      // 报表code
      code: '',
      // 报表自定义参数
      param: {},
      // 报表回选数据
      dataParams: {
        selectedRowKeys: [],
        selectionRows: [],
      }
    }))
  },
  data() {
    return {
      queryParam: {},
      dictOptions: {},
      tableScroll: { x: true },
      url: {
        getColumns: '/online/cgreport/api/getRpColumns/',
        getData: '/online/cgreport/api/getData/',
        getQueryInfo: '/online/cgreport/api/getQueryInfo/'
      },
      table: {
        loading: true,
        // 表头
        columns: [],
        //数据集
        dataSource: [],
        // 选择器
        selectedRowKeys: [],
        selectionRows: [],
        // 分页参数
        pagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return `${range[ 0 ]}-${range[ 1 ]}${this.$t('tip.total')}${total}${this.$t('tip.article')}`
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        }
      },
      cgRpConfigId: '',
      groupId: '',
      dynamicParam: {},
      queryInfo: [],
      toggleSearchStatus: false,
    }
  },
  computed: {
    showSearchFlag() {
      return this.queryInfo && this.queryInfo.length > 0
    },
    code() {
      return this.detailData.code
    },
    param() {
      return this.detailData.param
    },
    multi() {
      return this.detailData.multi
    }
  },
  watch: {
    code() {
      this.loadColumnsInfo()
    },
    param: {
      deep: true,
      handler() {
        this.dynamicParamHandler()
        this.loadData()
      }
    }
  },
  mounted() {
    this.show()
  },
  methods: {
    // 父组件获取选中数据
    getData() {
      return this.table.selectionRows
    },
    loadColumnsInfo() {
      if(!this.code) return
      let url = `${this.url.getColumns}${this.code}`
      //缓存key
      let groupIdKey
      if (this.groupId) {
        groupIdKey = this.groupId + url
      }
      httpGroupRequest(() => getAction(url), groupIdKey).then(res => {
        if (res.success) {
          this.initDictOptionData(res.result.dictOptions)
          this.cgRpConfigId = res.result.cgRpConfigId
          this.title = res.result.cgRpConfigName
          let currColumns = res.result.columns
          for (let a = 0; a < currColumns.length; a++) {
            if (currColumns[ a ].customRender) {
              let dictCode = currColumns[ a ].customRender
              currColumns[ a ].customRender = (text) => {
                return filterMultiDictText(this.dictOptions[ dictCode ], text + '')
              }
            }
          }
          let arr = []
          currColumns.forEach(column => {
            let slotName = this.$getLanguageEnable() ? `dynamic.${column.language_key}` : column.title
            arr.push({
              slotName,
              align: column.align,
              scopedSlots: { customRender: column.dataIndex, title: slotName },
              dataIndex: column.dataIndex,
              langKey: column.language_key,
              sorter: column.sorter,
              customRender: column.customRender
            })
          })
          this.table.columns = arr
          this.initQueryInfo()
        }
      })
    },
    initQueryInfo() {
      let url = `${this.url.getQueryInfo}${this.cgRpConfigId}`
      //缓存key
      let groupIdKey
      if (this.groupId) {
        groupIdKey = this.groupId + url
      }
      httpGroupRequest(() => getAction(url), groupIdKey).then((res) => {
        // console.log("获取查询条件", res);
        if (res.success) {
          this.dynamicParamHandler(res.result)
          this.queryInfo = res.result
          //查询条件加载后再请求数据
          this.loadData(1)
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //处理动态参数
    dynamicParamHandler(arr) {
      if (arr && arr.length > 0) {
        //第一次加载查询条件前 初始化queryParam为空对象
        let queryTemp = {}
        for (let item of arr) {
          if (item.mode === 'single') {
            queryTemp[ item.field ] = ''
          }
        }
        this.queryParam = { ...queryTemp }
      }
      let dynamicTemp = {}
      if (this.param) {
        Object.keys(this.param).map(key => {
          let str = this.param[ key ]
          if (key in this.queryParam) {
            if (str && str.startsWith('\'') && str.endsWith('\'')) {
              str = str.substring(1, str.length - 1)
            }
            //如果查询条件包含参数 设置值
            this.queryParam[ key ] = str
          }
          dynamicTemp[ key ] = this.param[ key ]
        })
      }
      this.dynamicParam = { ...dynamicTemp }
    },
    loadData(arg) {
      if(!this.cgRpConfigId) return
      if (arg == 1) {
        this.table.pagination.current = 1
      }
      let params = this.getQueryParams()//查询条件
      this.table.loading = true
      let url = `${this.url.getData}${this.cgRpConfigId}`
      //缓存key
      let groupIdKey
      if (this.groupId) {
        groupIdKey = this.groupId + url + JSON.stringify(params)
      }
      httpGroupRequest(() => getAction(url, params), groupIdKey).then(res => {
        this.table.loading = false
        // console.log("daa",res)
        let data = res.result
        if (data) {
          this.table.pagination.total = Number(data.total)
          this.table.dataSource = data.records
        } else {
          this.table.pagination.total = 0
          this.table.dataSource = []
        }
      })
    },
    getQueryParams() {
      let paramTarget = {}
      if (this.dynamicParam) {
        //处理自定义参数
        Object.keys(this.dynamicParam).map(key => {
          paramTarget[ 'self_' + key ] = this.dynamicParam[ key ]
        })
      }
      let param = Object.assign(paramTarget, this.queryParam, this.sorter)
      param.pageNo = this.table.pagination.current
      param.pageSize = this.table.pagination.pageSize
      return filterObj(param)
    },
    handleChangeInTableSelect(selectedRowKeys, selectionRows) {
      //update-begin-author:taoyan date:2020902 for:【issue】开源online的几个问题 LOWCOD-844
      if (!selectedRowKeys || selectedRowKeys.length == 0) {
        this.table.selectionRows = []
      } else if (selectedRowKeys.length == selectionRows.length) {
        this.table.selectionRows = selectionRows
      } else {
        //当两者长度不一的时候 需要判断
        let keys = this.table.selectedRowKeys
        let rows = this.table.selectionRows
        //这个循环 添加新的记录
        for (let i = 0; i < selectionRows.length; i++) {
          let combineKey = this.combineRowKey(selectionRows[ i ])
          if (keys.indexOf(combineKey) < 0) {
            //如果 原来的key 不包含当前记录 push
            rows.push(selectionRows[ i ])
          }
        }
        //这个循环 移除取消选中的数据
        this.table.selectionRows = rows.filter(item => {
          let combineKey = this.combineRowKey(item)
          return selectedRowKeys.indexOf(combineKey) >= 0
        })
      }
      //update-end-author:taoyan date:2020902 for:【issue】开源online的几个问题 LOWCOD-844
      this.table.selectedRowKeys = selectedRowKeys
    },
    handleChangeInTable(pagination, filters, sorter) {
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.sorter.column = sorter.field
        this.sorter.order = 'ascend' == sorter.order? 'asc': 'desc'
      }
      this.table.pagination = pagination
      this.loadData()
    },
    handleCancel() {
      this.close()
    },
    handleSubmit() {
      if (!this.multi) {
        if (this.table.selectionRows && this.table.selectionRows.length > 1) {
          this.$message.warning(this.$t('tip.pleaseSelectARecord'))
          return false
        }
      }
      if (!this.table.selectionRows || this.table.selectionRows.length == 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      this.$emit('ok', this.table.selectionRows)
      this.close()
    },
    show() {
      this.onClearSelected()
      this.loadColumnsInfo()
      // 第二次打开的时候选中已经存在于子表的数据
      if(this.detailData?.dataParams?.selectedRowKeys) {
        this.table.selectedRowKeys = this.detailData.dataParams.selectedRowKeys
        this.table.selectionRows = this.detailData.dataParams.selectionRows
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchByquery() {
      this.loadData(1)
    },
    onlyReload() {
      this.loadData()
    },
    searchReset() {
      Object.keys(this.queryParam).forEach(key => {
        this.queryParam[ key ] = ''
      })
      this.loadData(1)
    },
    onClearSelected() {
      this.table.selectedRowKeys = []
      this.table.selectionRows = []
    },
    combineRowKey(record) {
      if(record.id) return record.id
      let res = ''
      Object.keys(record).forEach(key => {
        res += record[ key ]
      })
      // 截取会出现key重复的情况
      // if (res.length > 50) {
      //   res = res.substring(0, 50)
      // }
      return res
    },
    clickThenCheck(record) {
      return {
        on: {
          click: () => {
            let rowKey = this.combineRowKey(record)
            if (!this.table.selectedRowKeys || this.table.selectedRowKeys.length == 0) {
              let arr1 = [], arr2 = []
              arr1.push(record)
              arr2.push(rowKey)
              this.table.selectedRowKeys = arr2
              this.table.selectionRows = arr1
            } else {
              if (this.table.selectedRowKeys.indexOf(rowKey) < 0) {
                this.table.selectedRowKeys.push(rowKey)
                this.table.selectionRows.push(record)
              } else {
                let rowKey_index = this.table.selectedRowKeys.indexOf(rowKey)
                this.table.selectedRowKeys.splice(rowKey_index, 1)
                this.table.selectionRows.splice(rowKey_index, 1)
              }
            }
          }
        }
      }
    },
    //防止字典中有垃圾数据
    initDictOptionData(dictOptions) {
      let obj = {}
      Object.keys(dictOptions).map(k => {
        obj[ k ] = dictOptions[ k ].filter(item => {
          return item != null
        })
      })
      this.dictOptions = obj
    }
  }
}
</script>